import { PaginatedResponse } from '@gorila-shared-ui/components';
import { atom, selector, selectorFamily } from 'recoil';
import { Group, GroupCore } from '../types/group';
import { apiParamsState } from './app';

export const loadingGroupsState = atom({
  key: 'app.client.groups.loading',
  default: false,
});

export const allGroupsState = atom<Group[] | undefined>({
  key: 'app.client.groups.all',
  default: undefined,
});

export const groupsState = atom<PaginatedResponse<Group> | undefined>({
  key: 'app.client.groups',
  default: undefined,
});

export const groupsPageState = atom({
  key: 'app.client.groups.page',
  default: 1,
});

export const groupIdsState = selector<string[] | undefined>({
  key: 'app.client.groupIds',
  get: ({ get }) => {
    const groups = get(groupsState);
    if (!groups) return;
    return groups.items.map((group) => group._id);
  },
});

export const groupState = selectorFamily<Group | undefined, string>({
  key: 'app.client.group',
  get:
    (id) =>
    ({ get }) => {
      const groups = get(allGroupsState);
      if (!groups) return;
      return groups.find((group) => group._id === id);
    },
});

export const selectedGroupIdState = atom<string | undefined>({
  key: 'app.client.groups.selected',
  default: undefined,
});

export const searchGroupState = atom<string | undefined>({
  key: 'app.client.groups.search',
  default: undefined,
});

export const editingGroupState = atom<GroupCore | undefined>({
  key: 'app.client.groups.editing',
  default: selector({
    key: 'app.client.groups.editing.initializer',
    get: ({ get }) => {
      const selectedGroupId = get(selectedGroupIdState);
      if (selectedGroupId === undefined) return;
      if (selectedGroupId === '') {
        const apiParams = get(apiParamsState);
        if (!apiParams) return;
        return {
          _id: '',
          client: apiParams.clientId,
          subClient: apiParams.subClientId,
          name: '',
          assignedAssets: [],
        };
      }
      return get(groupState(selectedGroupId));
    },
  }),
});

export const updateGroupsState = atom<string | undefined>({
  key: 'app.client.groups.update',
  default: undefined,
});
